module.exports = __webpack_public_path__ + "img/order-suc.22d88a09.png";